import { render, staticRenderFns } from "./evidencias.vue?vue&type=template&id=999f9c9e&"
import script from "./evidencias.vue?vue&type=script&lang=js&"
export * from "./evidencias.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports